import { render, staticRenderFns } from "./ApplySalary.vue?vue&type=template&id=a1287bd4&"
import script from "./ApplySalary.vue?vue&type=script&lang=js&"
export * from "./ApplySalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports